import { onMounted, onUnmounted, ref } from "vue"

export const useDragDetection = () => {
  const isDragging = ref(false)

  let timeout

  const onDragOver = (event: DragEvent) => {
    isDragging.value = true
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      isDragging.value = false
    }, 100)
  }

  onMounted(() => {
    window.addEventListener("dragover", onDragOver)
  })

  onUnmounted(() => {
    window.removeEventListener("dragover", onDragOver)
  })

  return {
    isDragging,
  }
}
